import React from 'react';

interface Props {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  half?: boolean;
}

export default function FormField({ label, required, children }: Props) {
  return (
    <div style={{marginBottom:14}}>
      <label style={{display:'block',fontSize:12,color:'var(--text-muted)',marginBottom:6}}>
        {label} {required && <span style={{color:'var(--danger)'}}>*</span>}
      </label>
      {children}
    </div>
  );
}

export const Input = (props: React.InputHTMLAttributes<HTMLInputElement>) => (
  <input {...props} style={{width:'100%',background:'var(--bg-input)',border:'1px solid #1e2d45',borderRadius:8,padding:'9px 12px',fontSize:13,color:'var(--text-secondary)',outline:'none',boxSizing:'border-box',...(props.style||{})}} />
);

export const Select = (props: React.SelectHTMLAttributes<HTMLSelectElement> & {children: React.ReactNode}) => (
  <select {...props} style={{width:'100%',background:'var(--bg-input)',border:'1px solid #1e2d45',borderRadius:8,padding:'9px 12px',fontSize:13,color:'var(--text-secondary)',outline:'none',boxSizing:'border-box'}} />
);

export const Textarea = (props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) => (
  <textarea {...props} style={{width:'100%',background:'var(--bg-input)',border:'1px solid #1e2d45',borderRadius:8,padding:'9px 12px',fontSize:13,color:'var(--text-secondary)',outline:'none',boxSizing:'border-box',resize:'vertical',minHeight:80,...(props.style||{})}} />
);

export const FormRow = ({children}: {children: React.ReactNode}) => (
  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>{children}</div>
);

export const SubmitBtn = ({loading, label}: {loading: boolean, label: string}) => (
  <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:20,paddingTop:16,borderTop:'1px solid #1e2d45'}}>
    <button type="submit" disabled={loading}
      style={{display:'flex',alignItems:'center',gap:6,padding:'9px 20px',background:'#1d4ed8',border:'none',borderRadius:8,color:'white',fontSize:13,fontWeight:500,cursor:'pointer',opacity:loading?0.6:1}}>
      {loading ? 'შენახვა...' : label}
    </button>
  </div>
);
